import { Typography } from '@mui/material';
import React from 'react';

export const LabelWithSubTitle: React.FC<{ title?: string | number | null | undefined; subTitle: string }> = (
    props
) => (
    <div>
        <Typography variant="body2" display="inline" style={{ lineHeight: 1.25, fontWeight: 600 }}>
            {props.title}
        </Typography>

        <Typography variant="body2" display="block" style={{ lineHeight: 1.25 }}>
            {props.subTitle}
        </Typography>
    </div>
);
